// TODO: expand to take in more types than just string[] and return appropriately guarded type
export const convertToString = (array: number[]): string[] =>
  array.map((id) => id.toString())
